import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Column, EmptyState } from "@neru/ui";
export var ErrorPage = function(param) {
    var error = param.error;
    return /*#__PURE__*/ _jsxs(Column, {
        className: "h-screen items-center justify-center",
        children: [
            /*#__PURE__*/ _jsx(EmptyState, {
                body: (error === null || error === void 0 ? void 0 : error.message) ? error === null || error === void 0 ? void 0 : error.message : "We're working to resolve this issue. Apologies for the inconvenience.",
                "data-testid": "error-state",
                heading: "Oops! Something went wrong.",
                icon: "error-star-line"
            }),
            /*#__PURE__*/ _jsx("div", {
                style: {
                    marginTop: "20px"
                },
                children: /*#__PURE__*/ _jsx(Button, {
                    "data-testid": "take-me-back-button",
                    label: "Take me back",
                    layout: "outlined",
                    onClick: function() {
                        window.history.back();
                        // Delay of 1 second to ensure the previous page loads first
                        setTimeout(function() {
                            return window.location.reload();
                        }, 1000);
                    },
                    shape: "pill",
                    type: "button"
                })
            })
        ]
    });
};

//# sourceMappingURL=ErrorPage.js.map